let _ctx: AudioContext | null = null
let _buf: AudioBuffer | null = null

function audioCtx(): AudioContext {
    if (!_ctx) {
        _ctx = new (
            window.AudioContext ||
            (
                window as unknown as {
                    webkitAudioContext: typeof AudioContext
                }
            ).webkitAudioContext
        )()
    }
    if (_ctx.state === "suspended") _ctx.resume()
    return _ctx
}

function ensureBuf(ac: AudioContext): AudioBuffer {
    if (_buf && _buf.sampleRate === ac.sampleRate) return _buf
    const rate = ac.sampleRate
    const len = Math.floor(rate * 0.006)
    const buf = ac.createBuffer(1, len, rate)
    const ch = buf.getChannelData(0)
    for (let i = 0; i < len; i++) {
        const t = i / len
        const sine = Math.sin(2 * Math.PI * 3400 * t)
        const noise = Math.random() * 2 - 1
        ch[i] = (sine * 0.6 + noise * 0.4) * (1 - t) ** 3
    }
    _buf = buf
    return buf
}

let _lastTime = 0
let _primed = false

/**
 * Spinning up the audio device costs ~130ms of main thread the first time it
 * happens. playToggleSound() runs before startViewTransition(), so paying that
 * on the first toggle stalls the whole reveal behind it — the press feels dead
 * for an eighth of a second. Spend it on an earlier gesture instead.
 */
export function primeToggleSound(): void {
    if (_primed || typeof window === "undefined") return
    _primed = true

    const prime = () => {
        window.removeEventListener("pointerdown", prime)
        window.removeEventListener("keydown", prime)
        try {
            const ac = audioCtx()
            const src = ac.createBufferSource()
            const gain = ac.createGain()
            src.buffer = ensureBuf(ac)
            // Silent: this exists to start the device, not to be heard.
            gain.gain.value = 0
            src.connect(gain)
            gain.connect(ac.destination)
            src.start()
        } catch {
            /* silent */
        }
    }

    // An AudioContext will not start until the page has seen a user gesture.
    window.addEventListener("pointerdown", prime)
    window.addEventListener("keydown", prime)
}

export function playToggleSound(): void {
    const now = performance.now()
    if (now - _lastTime < 80) return
    _lastTime = now
    try {
        const ac = audioCtx()
        const buf = ensureBuf(ac)
        const src = ac.createBufferSource()
        const gain = ac.createGain()
        src.buffer = buf
        gain.gain.value = 0.08
        src.connect(gain)
        gain.connect(ac.destination)
        src.start()
    } catch {
        /* silent */
    }
}
